// extracted by mini-css-extract-plugin
module.exports = {"network":"NetworkName-module--network--13b-i","icon":"NetworkName-module--icon--cZ5BC","minimal":"NetworkName-module--minimal--3fvRz","name":"NetworkName-module--name--3vSLi"};